export class Assistencia {
  private id: number;
  private valor: number;
  private bem: number;

  constructor(id?: number, valor?: number, bem?: number) {
    this.id = id;
    this.valor = valor;
    this.bem = bem;
  }
}
